export type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>
    }
  : T

export type EnumToStringUnion<T extends Record<string, number | string>> = `${T[keyof T]}`

export function isKeyOf<T extends object>(key: PropertyKey, obj: T): key is keyof T {
  return key in obj
}
